import { createContext, useContext } from 'react';
import type { EtatSession, ServiceAuth, Utilisateur } from './types';

export const ContexteAuth = createContext<{
  etat: EtatSession;
  service: ServiceAuth;
  /** Relit la session : après un changement du profil (nom, photo). */
  relire: () => void;
} | null>(null);

export function useAuth() {
  const contexte = useContext(ContexteAuth);
  if (!contexte) throw new Error('useAuth doit être appelé sous <AuthProvider>.');
  return contexte;
}

/** L'utilisateur connecté. À n'appeler que sous un garde qui l'a déjà vérifié. */
export function useUtilisateur(): Utilisateur {
  const { etat } = useAuth();
  if (etat.statut !== 'connecte') throw new Error('useUtilisateur hors d’une session ouverte.');
  return etat.utilisateur;
}
